<template>
  <div class="content">
    <table class="table-container">
      <tr class="table-header">
        <th>Дата и время</th>
        <th>КПП</th>
        <th>Тип проезда</th>
        <th>Линия проезда</th>
        <th>Фото</th>
        <th>Авто</th>
      </tr>
      <tr v-for="(face, key) in faces" :key="key" class="table-row">
        <td>{{ face.DATETIME }}</td>
        <td>{{ face.KPP_NAME }}</td>
        <td>{{ face.EVENT_NAME }}</td>
        <td>{{ face.ACCESSLINE_ID }}</td>
        <td><img v-if="face.PHOTO" v-bind:src="url+'../data/event_pics/'+face.PHOTO+'.png'"></td>
        <td>{{ face.NUMBER }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "TabEvents",
  data() {
    return {
      id: this.$route.params.id,
      url: config.backend_url,
      faces: []
    };
  },
  computed: {},
  watch: {},
  methods: {
    getPlotData: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "plots/get-plot-events/",
          data: { ID: this.id },
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          console.log(data);
          if (!data.error) this.faces = data;
        });
    }
  },
  created() {
    this.getPlotData();
  }
};
</script>
